export const CommonInstitutionCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Enti',
    path: '/sistema/enti',
  },
];
